// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoCard_container__7URhE","image":"InfoCard_image__4qlyZ","author-image":"InfoCard_author-image__ttfgi","title":"InfoCard_title__Kc_a0","name":"InfoCard_name__G4KoV"};